// Static site data and asset paths for the Raintree Holdings one-pager.
const PUBLIC = process.env.PUBLIC_URL;

export const EMBLEM = `${PUBLIC}/assets/raintree-emblem-aulait.svg`;
export const LINEAR_LOGO = `${PUBLIC}/assets/raintree-linear-aulait.png`;
export const HERO_VIDEO = `${PUBLIC}/assets/ocean-hero.mp4`;
export const REALESTATE_VIDEO = `${PUBLIC}/assets/realestate.mp4`;

const RE_BASE = `${PUBLIC}/assets/realestate`;

export const REAL_ESTATE_CATEGORIES = [
  {
    label: "Residential",
    photos: [
      { src: `${RE_BASE}/juniper-flats.jpg`, caption: "Juniper Flats" },
      { src: `${RE_BASE}/huckleberry-flats.jpg`, caption: "Huckleberry Flats" },
    ],
  },
  {
    label: "Commercial Retail",
    photos: [
      { src: `${RE_BASE}/coffee-project.jpg`, caption: "The Coffee Project" },
      { src: `${RE_BASE}/monarch.jpg`, caption: "Monarch" },
    ],
  },
  {
    label: "Commercial Industrial",
    photos: [
      { src: `${RE_BASE}/sheringham.jpg`, caption: "Sheringham Distillery" },
    ],
  },
];

export const PORTFOLIO = [
  { name: "DeeBee’s Organics", url: "https://www.deebeesorganics.com/" },
  { name: "Flytographer", url: "https://www.flytographer.com" },
  { name: "Sheringham Distillery", url: "https://www.sheringhamdistillery.com/" },
  { name: "Teamshares", url: "https://www.teamshares.com/" },
  { name: "Opal", url: "https://opalspend.com/" },
  { name: "joni", url: "https://getjoni.com/" },
  { name: "Low Vacancy", url: "https://lowvacancy.ca/" },
  { name: "RentSimple", url: "https://www.rent-simple.com/" },
];
